/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { CompanyReservationWrite } from './company-reservation-write';
// May contain unused imports in some cases
// @ts-ignore
import { ContactReservationWrite } from './contact-reservation-write';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationDayReservationWrite } from './reservation-day-reservation-write';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationMailReservationWrite } from './reservation-mail-reservation-write';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationRemarkReservationWrite } from './reservation-remark-reservation-write';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationRoomReservationWrite } from './reservation-room-reservation-write';

/**
 * A hotelroom and/or MICE reservation made (part of case).
 * @export
 * @interface ReservationWrite
 */
export interface ReservationWrite {
  /**
   * virtual property for creating the user after the new request is received
   * @type {string}
   * @memberof ReservationWrite
   */
  emailaddress?: string;
  /**
   * virtual property which indicates if a reservation is an alternative for the initially requested reservation
   * @type {boolean}
   * @memberof ReservationWrite
   */
  isAlternative?: boolean;
  /**
   * firstname of the contactperson
   * @type {string}
   * @memberof ReservationWrite
   */
  contactpersonFirstname?: string | null;
  /**
   * lastname of the contactperson
   * @type {string}
   * @memberof ReservationWrite
   */
  contactpersonLastname?: string | null;
  /**
   * company of the contactperson
   * @type {string}
   * @memberof ReservationWrite
   */
  company?: string | null;
  /**
   * chamber of commerce number of the company
   * @type {string}
   * @memberof ReservationWrite
   */
  coc?: string | null;
  /**
   * streetname of the company
   * @type {string}
   * @memberof ReservationWrite
   */
  street?: string | null;
  /**
   * housenumber of the company
   * @type {string}
   * @memberof ReservationWrite
   */
  housenumber?: string | null;
  /**
   * zipcode of the company
   * @type {string}
   * @memberof ReservationWrite
   */
  postalcode?: string | null;
  /**
   * city of the company
   * @type {string}
   * @memberof ReservationWrite
   */
  city?: string | null;
  /**
   * country of the company in a 2 letter ISO 3166 format (default NL)
   * @type {string}
   * @memberof ReservationWrite
   */
  country?: string | null;
  /**
   * phonenumber of the contactperson
   * @type {string}
   * @memberof ReservationWrite
   */
  phonenumber?: string | null;
  /**
   * phonenumber of the company
   * @type {string}
   * @memberof ReservationWrite
   */
  companyPhonenumber?: string | null;
  /**
   * indicates of the contactperson would like to receive newsletters
   * @type {boolean}
   * @memberof ReservationWrite
   */
  newsletter?: boolean;
  /**
   * used for persisting the unprocessed address retrieved by the processor
   * @type {string}
   * @memberof ReservationWrite
   */
  unprocessedAddress?: string | null;
  /**
   * the name of the event
   * @type {string}
   * @memberof ReservationWrite
   */
  eventname?: string | null;
  /**
   * the name of the event that should be displayed at the hall entry
   * @type {string}
   * @memberof ReservationWrite
   */
  hallEntry?: string | null;
  /**
   * name of the contactperson on location
   * @type {string}
   * @memberof ReservationWrite
   */
  contactpersonLocation?: string | null;
  /**
   * a reference for the invoice provided by the customer
   * @type {string}
   * @memberof ReservationWrite
   */
  invoiceReference?: string | null;
  /**
   * an additional comment about the invoice reference
   * @type {string}
   * @memberof ReservationWrite
   */
  invoiceReferenceComment?: string | null;
  /**
   * percentage of commission
   * @type {number}
   * @memberof ReservationWrite
   */
  commission?: number;
  /**
   * the discount in percentage given on the total invoice
   * @type {string}
   * @memberof ReservationWrite
   */
  invoiceDiscount?: string;
  /**
   * the method the customer should use for the payment
   * @type {string}
   * @memberof ReservationWrite
   */
  paymentMethod?: string | null;
  /**
   * the locale/language for this reservation (ISO 3166). if available, the mails to customer will be sent in this language
   * @type {string}
   * @memberof ReservationWrite
   */
  locale?: string;
  /**
   * use the overbook option in the external system
   * @type {boolean}
   * @memberof ReservationWrite
   */
  overbookMeeting?: boolean;
  /**
   * the date when an option will expire
   * @type {string}
   * @memberof ReservationWrite
   */
  expirationDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReservationWrite
   */
  tagtogUrl?: string | null;
  /**
   * the text representation of cancellation reason
   * @type {string}
   * @memberof ReservationWrite
   */
  cancelReasonText?: string | null;
  /**
   * the reference of the agency
   * @type {string}
   * @memberof ReservationWrite
   */
  agencyReference?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationWrite
   */
  flags?: Array<string>;
  /**
   *
   * @type {Array<ReservationDayReservationWrite>}
   * @memberof ReservationWrite
   */
  days?: Array<ReservationDayReservationWrite>;
  /**
   *
   * @type {Array<ReservationRoomReservationWrite>}
   * @memberof ReservationWrite
   */
  rooms?: Array<ReservationRoomReservationWrite>;
  /**
   *
   * @type {Array<ReservationRemarkReservationWrite>}
   * @memberof ReservationWrite
   */
  remarks?: Array<ReservationRemarkReservationWrite>;
  /**
   *
   * @type {Array<ReservationMailReservationWrite>}
   * @memberof ReservationWrite
   */
  mails?: Array<ReservationMailReservationWrite>;
  /**
   * a fee should be added if the customer cancels the reservation
   * @type {boolean}
   * @memberof ReservationWrite
   */
  cancellationFee?: boolean | null;
  /**
   * location of the reservation where to booking should take place
   * @type {string}
   * @memberof ReservationWrite
   */
  location?: string | null;
  /**
   * type of meeting
   * @type {string}
   * @memberof ReservationWrite
   * @deprecated
   */
  meeting?: string | null;
  /**
   * used contract for this reservation
   * @type {string}
   * @memberof ReservationWrite
   */
  contract?: string | null;
  /**
   * related case
   * @type {string}
   * @memberof ReservationWrite
   */
  dossier?: string | null;
  /**
   * The executor is an intermediate party, like a travel agent.
   * @type {ContactReservationWrite}
   * @memberof ReservationWrite
   */
  executorContact?: ContactReservationWrite;
  /**
   *
   * @type {CompanyReservationWrite}
   * @memberof ReservationWrite
   */
  executorCompany?: CompanyReservationWrite;
  /**
   * related contact on site
   * @type {ContactReservationWrite}
   * @memberof ReservationWrite
   */
  onsiteContact?: ContactReservationWrite;
  /**
   * related partner
   * @type {string}
   * @memberof ReservationWrite
   */
  partner?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationWrite
   */
  types?: Array<ReservationWriteTypesEnum>;
  /**
   * shows the source of the reservation (phone, manually, mail etc.)
   * @type {string}
   * @memberof ReservationWrite
   */
  source?: ReservationWriteSourceEnum;
  /**
   * the url to the terms and condition at the time of the reservation
   * @type {string}
   * @memberof ReservationWrite
   */
  termsUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReservationWrite
   */
  bookingEventType?: string | null;
}

export const ReservationWriteTypesEnum = {
  Mice: 'mice',
  Hotel: 'hotel',
} as const;

export type ReservationWriteTypesEnum =
  (typeof ReservationWriteTypesEnum)[keyof typeof ReservationWriteTypesEnum];
export const ReservationWriteSourceEnum = {
  Broker: 'broker',
  Mail: 'mail',
  Form: 'form',
  Booking: 'booking',
  Employee: 'employee',
  Phone: 'phone',
} as const;

export type ReservationWriteSourceEnum =
  (typeof ReservationWriteSourceEnum)[keyof typeof ReservationWriteSourceEnum];
